/**
 * @description Truncates text for given length
 *
 * @param text actual text to be truncated
 * @param maxLength Length after which text needs to truncated
 * @return string
 */
export function truncateText(text: string, maxLength: number): string {
  if (text.length <= maxLength) {
    return text;
  }
  return text.slice(0, maxLength) + '...';
}

/**
 * @description remove square brackets and curly braces,
 * should escape non-word characters with square brackets and wrap in square brackets
 *
 * @param keyword actual text to be processed (Input: remove [square] and {curly} braces specialChar:$@#^*)
 * @return processed string (Input: remove[ ]square[ ]and[ ]curly[ ]braces[] ]specialChar[:][$][@][#][^][*])
 */
export function freetextEscapeSymbols(keyword: string): string {
  let modifiedKeyword = keyword.replace(/[\[\{]|[\]\}]/gi, '');
  modifiedKeyword = modifiedKeyword.replace(/\W/gi, '[$&]');
  return modifiedKeyword;
}

/**
 * @description Converts a string to title case
 * @param input The string to be converted
 * @return string in title case
 */
export function convertToTitleCase(input: string): string {
  return input
    .toLowerCase()
    .replace(/\b\w/g, (char: string) => char.toUpperCase());
}
